import React from 'react'
import classNames from 'classnames'

import { IButtonProps } from './types'

export const Button = React.forwardRef<HTMLButtonElement, IButtonProps>(
  ({ loading, disabled, className, children, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        {...rest}
        className={classNames(className, {
          disabled: !!disabled,
        })}
        disabled={disabled || loading}
      >
        {children}
      </button>
    )
  },
)

Button.displayName = 'Button'
